import React from 'react';

/**
 * Small loading bar that appears in the top-right of the map while bike tiles
 * are being fetched. Disappears automatically when progress reaches 100 / null.
 *
 * @param {number} progress - 0–100
 */
export default function BikeLoadingBar({ progress }) {
  return (
    <div className="bike-loading-bar" role="status" aria-label={`Loading bike trails: ${progress}%`}>
      <span className="bike-loading-bar__label">Loading bike trails…</span>
      <div className="bike-loading-bar__track" aria-hidden="true">
        <div
          className="bike-loading-bar__fill"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
